<template>
  <BusinessUserTimeManagement v-if="isShow" />
</template>
<script>
  import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
  import pageMiXin from '@/utils/page-mixin.js';
  import BusinessUserTimeManagement from '@/views/center-business/user/hour';
  import { commonApi } from '@/api';
  import { setToken } from '@/utils/auth';

  export default {
    components: { BusinessUserTimeManagement },
    mixins: [pageMiXin],
    data() {
      return {
        isShow: false,
      };
    },
    created() {
      this.ensureDingTalkLandscape();
    },
    mounted() {
      if (this.ensureDingTalkLandscape()) {
        return;
      }

      const vm = this;
      dd.ready(function() {
        dd.runtime.permission.requestAuthCode({
          corpId: vm.getCorpIdFromUrl(), // 企业id
          onSuccess: function (info) {
            const code = info.code; // 通过该免登授权码可以获取用户身份
            vm.getLoginStatus(code);
          },
        });
      });
    },
    methods: {
      ensureDingTalkLandscape() {
        const url = new URL(window.location.href);

        if (url.searchParams.get('dd_orientation') === 'landscape') {
          return false;
        }

        url.searchParams.set('dd_orientation', 'landscape');
        window.location.replace(url.toString());
        return true;
      },
      getCorpIdFromUrl() {
        const regex = /[?&]corpid=([^&]+)/g;
        const match = regex.exec(window.location.href);
        return match ? match[1] : null;
      },
      getLoginStatus(code) {
        commonApi.DingtalkDingHoursPageLogin({ code: code }).then(res => {
          setToken(res.access_token);
          this.isShow = true;
        });
      },
    },
  };
</script>
